// extracted by mini-css-extract-plugin
module.exports = {"promotion":"_3e0e9df","promotionInfo":"_4e40716","promotionAmount":"_366e12b","promotionExpiry":"_885147f","radio":"_5009c4a","add":"_5be7c99"};